import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { USER_ROLE_ADMIN, USER_ROLE_FIELD_OPS } from 'common/userRoles';

import { SCREEN_ID_ADMIN_SR_LISTINGS_PAGE } from 'client/constants/screenIds';

import allowedRoles from 'client/helpers/allowedRoles';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';

import SrDataTableListings from 'client/components/SrDataTableListings';
import SrPage from 'client/components/SrPage';
import SrUserSettingListingStatusDropdown from 'client/components/SrUserSettingListingStatusDropdown';
import SrUserSettingListingManagementCompanyDropdown from 'client/components/SrUserSettingListingManagementCompanyDropdown';
import SrUserSettingFilterListDropdown from 'client/components/SrUserSettingFilterListDropdown';
import SrUserSettingMonthsDropdown from 'client/components/SrUserSettingMonthsDropdown';
import SrUserSettingListingServicesDropdown from 'client/components/SrUserSettingListingServicesDropdown';

import branch from 'client/core/branch';
import PartnerActions from 'client/actions/Partner';
import AccountManagerActions from 'client/actions/AccountManager';
import LeasingManagerActions from 'client/actions/LeasingManager';

@withTransitionHook
@allowedRoles({
  roles: [USER_ROLE_ADMIN, USER_ROLE_FIELD_OPS],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@withScreenId(SCREEN_ID_ADMIN_SR_LISTINGS_PAGE)
@withScrollToTop
@branch({
  currentUser: ['currentUser'],
  accountManagersList: ['accountManagers', 'listWithPartners'],
  leasingManagersList: ['leasingManagers', 'listWithPartners'],
})
class AdminSrListingsPage extends Component {
  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
  };

  static fetchData(match, inject) {
    return Promise.all([
      PartnerActions.getPartnerList(inject),
      AccountManagerActions.getListWithPartners(inject),
      LeasingManagerActions.getListWithPartners(inject),
    ]);
  }

  static getPageMetadata = () => ({
    pageTitle: 'Listings | Sunroom Rentals',
  });

  render() {
    const { currentUser, dispatch, accountManagersList, leasingManagersList } = this.props;

    const userSettings = currentUser.settings.adminListings || {};

    return (
      <SrPage navbarProps={{ redirectLogoTo: '/admin' }}>
        <div className="AdminSrListingsPage width-90">
          <div className="subNavbar">
            <div />
            <div className="filtersSection">
              <div className="filter">
                <SrUserSettingListingStatusDropdown
                  currentUser={currentUser}
                  settingField="adminListings.listingStatus"
                  dispatch={dispatch}
                />
              </div>
              <div className="filter">
                <SrUserSettingListingManagementCompanyDropdown
                  currentUser={currentUser}
                  settingField="adminListings.listingManagementCompany"
                  placeholder="Partner"
                  allPartners
                />
              </div>
              <div className="filter">
                <SrUserSettingFilterListDropdown
                  currentUser={currentUser}
                  settingField="adminListings.partnerAccountManagerId"
                  placeholder="Account Manager"
                  optionsList={accountManagersList}
                />
              </div>
              <div className="filter">
                <SrUserSettingFilterListDropdown
                  currentUser={currentUser}
                  settingField="adminListings.partnerLeasingOperationsManagerId"
                  placeholder="Leasing Manager"
                  optionsList={leasingManagersList}
                />
              </div>
              <div className="filter">
                <SrUserSettingMonthsDropdown
                  currentUser={currentUser}
                  settingField="adminListings.listingAvailableDates"
                  startIndexMonth={-6}
                  endIndexMonth={6}
                  placeholder="available date"
                  dispatch={dispatch}
                />
              </div>
              <div className="filter">
                <SrUserSettingListingServicesDropdown
                  currentUser={currentUser}
                  settingField="adminListings.listingServices"
                  placeholder="Listing Type"
                  dispatch={dispatch}
                />
              </div>
            </div>
          </div>
          <SrDataTableListings {...userSettings} />
        </div>
      </SrPage>
    );
  }
}

AdminSrListingsPage.displayName = 'AdminSrListingsPage';

export default AdminSrListingsPage;
